import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    label: 'body-5',
    ring: 'ring-transparent rounded-md',
    rounded: 'rounded-md',
    swatch: 'h-8 w-18.5',
    swatchDisabled: 'op-50',
    swatchInnerDisabled: '!inset-0.5',
    swatchInner: 'rounded-md inset-0.25'
  },
  hasIcon: false
} satisfies VfConfig['colorFilter']
